import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Product } from 'src/app/models/class/product';
import { ProdDetail } from 'src/app/models/class/prod-detail';
import { ToolsService } from '../../tools/tools.service';
import { ClientaddressesService } from '../../apiclient/clientaddresses/clientaddresses.service';
import * as _ from "lodash";
import { v4 as uuidv4 } from 'uuid';
import { cloneDeep } from 'lodash';
import { TranslateService } from '@ngx-translate/core';
import { SalemethodService } from "../../api/salemethod/salemethod.service";

@Injectable({
  providedIn: 'root'
})
export class PanierService {
  public static TAG_STORAGE: string = "basket"
  private currPanier: BehaviorSubject<Product[]> = new BehaviorSubject<Product[]>([]);
  private recoveryOrderChanges: BehaviorSubject<any> = new BehaviorSubject(null);
  constructor(
    private tools: ToolsService,
    private addressApi: ClientaddressesService,
    public translate: TranslateService
  ) { }

  // Set basket in localstorage and in observable
  setPanier(val: any) {
    // On notifie le changement du panier
    this.currPanier.next(val);
    // Le panier n'est pas vide
    if (val && val.length) {
      // Stockage
      this.tools.setStor(PanierService.TAG_STORAGE, val)
    }
    else {
      // Suppression des données en storage
      this.tools.removeStor(PanierService.TAG_STORAGE)
    }
  }

  // Remove all basket
  removePanier() {
    // On notifie le vidage du panier
    this.currPanier.next([]);
    // Suppression des données en storage
    this.tools.removeStor(PanierService.TAG_STORAGE);
  }

  get getPanier(): Observable<Product[]> {
    return this.currPanier.asObservable();
  }

  issetPanier(): boolean {
    return this.currPanier.getValue().length > 0;
  }

  // Add product to basket (product_type 0 and 1)
  manageProduct(prod: any, stock?: any, index?: number) {
    // prod.product_type < 2 TODO MAGIC NUMBER
    const details: any = [];
    if (prod.details && prod.details.length > 0) {
      prod.details.map((det: any) => {
        const newDet = new ProdDetail(
          det.id,
          det.cat,
          det.quantity,
          det.name,
          det.price,
          det.comment,
          det.image,
          det.rubric,
          det.display_lang,
          det.suggestions
        )
        details.push(newDet);
      });
    }

    const newProd = new Product(
      prod.id ? prod.id : prod.id,
      prod.cat,
      prod.quantity,
      prod.name,
      prod.comment,
      prod.price || prod.price === 0 ? prod.price : prod.prices[0].price,
      prod.weight,
      prod.product_type,
      details,
      prod.categories,
      prod.description,
      prod.image,
      prod.stock,
      prod.has_stock,
      prod.fidelity_points,
      prod.use_fidelity_points,
      prod.free,
      prod.uid,
      prod.rubric,
      prod.display_lang,
      prod.id_tax_grouping = prod.prices && prod.prices.length > 0 ? prod.prices[0].id_tax_grouping : null,
      prod.suggestions
    );
    this.setCurrentBasket(newProd, "add", stock, index);
  }

  initQuant(panier: any) {
    panier.map((prod: any) => {
      if (prod.product_type < 2) {
        !prod.stock ? this.changeQuantities(prod, 30) : prod.stock.count < 30 ? this.changeQuantities(prod) : this.changeQuantities(prod, 30)
      } else {
        const cumulProd_Type: any = [];
        for (let i = 0; i < prod.details.length; i++) {
          const det = prod.details[i]
          // pour l'ascenseur
          if (det.stock) {
            if (!cumulProd_Type[det.id.toString()]) {
              cumulProd_Type[det.id.toString()] = {
                newCount: 0,
                count: det.stock.count,
                id: det.id,
                qte: 0,
                quotient: 0
              };
            }
            cumulProd_Type[det.id.toString()].newCount += det.quantity;
            cumulProd_Type[det.id.toString()].qte += det.quantity * prod.quantity;
          }
        }
        //repasse array objet
        const transformArray = Object.keys(cumulProd_Type).map(function (k) {
          return cumulProd_Type[k];
        });
        if (transformArray.length > 0) {
          transformArray.map(det => {
            det.quotient = det.count / det.qte;
          })
          //on recupere le plus petit quotient
          const min = (a: any, f: any) => a.reduce((m: any, x: any) => m[f] < x[f] ? m : x);
          const result = min(transformArray, 'quotient');
          const calc = (result.count + result.qte) / result.newCount;
          let qte = Math.floor(calc);
          //on bloque à 30
          if (qte >= 30) {
            qte = 30;
          }
          this.changeQuantities(prod, qte);
        } else {
          this.changeQuantities(prod, 30);
        }
      }
    })
  }

  changeQuantities(product?: any, qte?: number) {
    const arrayQuants = [];
    let min = 1;
    let max = 0;
    max = !qte ? (product.stock ? product.stock.count + product.quantity : 0) : qte;
    if (max >= 30) {
      max = 30
    }
    while (min <= max) {
      arrayQuants.push(min);
      min++;
    }
    product.quantities = arrayQuants;
  }

  setCurrentBasket(newProduct: any, instructions: any, stock?: any, index?: any) {
    const newPan = instructions != 'updateStock' ? _.cloneDeep(this.currPanier.getValue()) : newProduct;
    //ajout ou modification
    if (instructions == "add") {
      (index >= 0) ? newPan[index] = newProduct : newPan.push(newProduct);
      const snackMessage = (index >= 0) ? this.translate.instant('modifiProd') : this.translate.instant('addedProd');
      this.tools.openSnackBar(snackMessage, "great");
    }
    // stock dans le panier
    if (stock) {
      newPan.map((prodPan: any) => {
        prodPan.stock = stock[prodPan.id.toString()];
        if (prodPan.categories && prodPan.categories.length > 0 && prodPan.details.length > 0) {
          prodPan.details.map((prodPandet: any) => {
            prodPandet.stock = stock[prodPandet.id.toString()];
          })
        }
      })
    }
    this.initQuant(newPan);
    const newPancopy = this.removeCat(cloneDeep(newPan));
    //ajout au panier
    this.setPanier(newPancopy);
  }

  //remove cat  more
  removeCat(newPan: any) {
    if (newPan && newPan.length > 0) {
      newPan.forEach((element: any) => {
        element.categories = [];
        if (element.details) {
          element.details.forEach((elemDet: any) => {
            elemDet.categories = [];
          });
        }
      });
    }
    return newPan;
  }

  // Add formule to basket (product_type 2)
  manageProductFormule(prod: any, dets: any[], stock?: any, index?: number) {
    const details: any = [];
    dets.map(det => {
      const sDetails: any = [];
      if (det.details) {
        det.details.map((sDet: any) => {
          const sNewDetail = new ProdDetail(
            sDet.id,
            sDet.cat,
            sDet.quantity,
            sDet.name,
            sDet.price,
            sDet.comment,
            sDet.image,
            sDet.rubric,
            sDet.display_lang,
            sDet.suggestions
          )
          sDetails.push(sNewDetail);
        })
      }
      const newDetail = new Product(
        det.id,
        det.cat,
        det.quantity,
        det.name,
        det.comment,
        det.price,
        det.weight,
        det.product_type,
        sDetails,
        det.categories,
        det.description,
        det.image,
        det.stock,
        det.has_stock,
        det.fidelity_points,
        det.use_fidelity_points,
        det.free,
        det.uid,
        det.rubric,
        det.display_lang,
        det.id_tax_grouping,
        det.suggestions
      );
      details.push(newDetail);
    });
    const newProd = new Product(
      prod.id,
      prod.cat,
      prod.quantity,
      prod.name,
      prod.comment,
      prod.price ? prod.price : !prod.prices || (prod.prices && prod.prices.length) == 0 ? 0 : prod.prices[0].price,
      prod.weight,
      prod.product_type,
      details,
      prod.categories,
      prod.description,
      prod.image,
      prod.stock,
      prod.has_stock,
      prod.fidelity_points,
      prod.use_fidelity_points,
      prod.free,
      prod.uid,
      prod.rubric,
      prod.display_lang,
      prod.id_tax_grouping = prod.prices && prod.prices.length > 0 ? prod.prices[0].id_tax_grouping : null,
      prod.suggestions
    );
    this.setCurrentBasket(newProd, "add", stock, index);
  }

  // Remove product from basket
  removeProduct(index: number) {
    const newPan: any = this.currPanier.getValue();
    newPan.splice(index, 1);
    newPan.length === 0 ? this.removePanier() : this.setPanier(newPan);
    this.tools.openSnackBar(this.translate.instant('deleteProd'), "great");
  }

  // Set the basket observable if basket exist in localstorage
  initPanier(): Promise<any> {
    const storPan: any = this.tools.getStor(PanierService.TAG_STORAGE);
    if (storPan) {
      this.currPanier.next(storPan);
    }
    return storPan;
  }

  // Calcul the price total of a product
  getProdTotal(prod: any): number {
    let countTot = 0;
    // !!Attention!! On se base sur une quantité de 1 par détail du produit puis on multiplie par le quantité du produit à la fin.
    if (prod.details && prod.details.length > 0) {
      prod.details.map((det: any) => {
        if (det.details && det.details.length > 0) {
          det.details.map((sdet: any) => {
            countTot += sdet.price;
          });
        }
        if (det.price >= 0) {
          countTot += det.price;
        }
      });
    }
    const total = !prod.free ? (prod.price * prod.quantity) + (countTot * prod.quantity) : 0;
    return (Math.round(total * 100) / 100);
  }

  // Get some basket informations
  getPanInfos(type: string, relay?: any, uberFee?: number) {
    // console.log("panier.service - getPanInfos - type : ", type);
    // console.log("panier.service - getPanInfos - relay : ", relay);
    // console.log("panier.service - getPanInfos - uberFee : ", uberFee);
    const currSM: any = this.tools.getStor(SalemethodService.TAG_STORAGE);
    const shippingSettings =
      currSM && currSM.enable_shipping_cost > 0
        ? this.addressApi.getShippingCostsSettings()
        : null;
    const delivrySettings =
      currSM && currSM.enable_delivery > 0
        ? this.addressApi.getDelivrySettings()
        : null;
    let delivryPrice =
      currSM && currSM.enable_delivery > 0
        ? delivrySettings
          ? delivrySettings.delivery_price
          : null
        : null;
    const totalPrice = this.getPrice();
    const totalWeight = this.getWeight();
    let shippingAndDeliveryPrice = this.addressApi.getShippingPrice(
      this.currPanier.getValue(),
      relay
    );
    if (type === "delivery") {
      //port offert
      if (delivrySettings && delivrySettings.offered_from && totalPrice > delivrySettings.offered_from) {
        delivryPrice = 0;
      }
      if (uberFee && uberFee > 0) {
        delivryPrice = uberFee;
        shippingAndDeliveryPrice = 0;
      }
      return delivryPrice;
    } else if (type === "deliveryOffer") {
      return delivrySettings ? delivrySettings.offered_from : null;
    } else if (type === "shippingOffer") {
      return shippingSettings ? shippingSettings.offered_from : null;
    } else if (type === "allship") {
      if (
        delivrySettings &&
        delivrySettings.offered_from &&
        totalPrice > delivrySettings.offered_from
      ) {
        delivryPrice = 0;
      }
      if (
        shippingSettings &&
        shippingSettings.offered_from &&
        totalPrice > shippingSettings.offered_from
      ) {
        shippingAndDeliveryPrice = 0;
      }
      if (uberFee && uberFee > 0) {
        // Si Uber est utilisé, on remplace la livraison classique par Uber
        delivryPrice = uberFee;
        shippingAndDeliveryPrice = 0;
      }
      // console.log("panier.service - getPanInfos - totalPrice : ", totalPrice);
      // console.log("panier.service - getPanInfos - shippingAndDeliveryPrice : ", shippingAndDeliveryPrice);
      // console.log("panier.service - getPanInfos - delivryPrice : ", delivryPrice);
      return (
        Math.round(
          (totalPrice +
            (shippingAndDeliveryPrice >= 0 ? shippingAndDeliveryPrice : 0) +
            (delivryPrice ? delivryPrice : 0)) *
          100
        ) / 100
      );
    }
    else if (type === "weight") {
      return Math.round(totalWeight * 100) / 100;
    }
  }

  getPriceWithDiscountClientAndFidelity(price: any, discountClient: any = 0, fidelityTrade: any = 0) {
    const total: any = price - discountClient - fidelityTrade;
    return Math.round(total * 100) / 100;
  }

  // Récupère le poids du panier
  getWeight(): number {
    const panier = this.currPanier.getValue();
    let totalWeight = 0;
    panier.map(prod => {
      if (prod.weight) {
        totalWeight += (prod.weight * prod.quantity);
      }
    });
    return (Math.round(totalWeight * 100) / 100);
  }

  // Récupère le poids maximum
  getMaxWeight(): number {
    const currSM: any = this.tools.getStor(SalemethodService.TAG_STORAGE);
    const shippingSettings = (currSM && currSM.enable_shipping_cost > 0) ? this.addressApi.getShippingCostsSettings() : null;
    const shippingCosts = (currSM && currSM.enable_shipping_cost > 0) ? shippingSettings ? shippingSettings.costs : null : null;
    const maxWeight = shippingCosts ? shippingCosts[shippingCosts.length - 1].max_weight : null;
    return maxWeight;
  }

  // Récupère le nombre de produit dans le panier
  getQuant(): number {
    const panier = this.currPanier.getValue();
    let totalQuant = 0;
    panier.map(prod => {
      totalQuant += prod.quantity;
    });
    return totalQuant;
  }

  // Récupère le prix total du panier sans les frais
  getPrice(): number {
    const panier = this.currPanier.getValue();
    let totalPrice = 0;
    panier.map(prod => {
      if (!prod.free) {
        totalPrice += prod.total_ttc;
      }
    });
    return totalPrice;
  }

  getTotalAfterDiscount(merchantClient: any) {
    const panier = this.currPanier.getValue();
    let countTot = 0;
    if (panier && panier.length > 0) {
      panier.map((products: any) => {
        if (products.details && products.details.length > 0) {
          products.details.map((det: any) => {
            if (det.details && det.details.length > 0) {
              det.details.map((sdet: any) => {
                countTot += !sdet.free ? (this.chechDiscount(merchantClient, sdet.price, sdet) * products.quantity * sdet.quantity) : 0
              });
            }
            countTot += !det.free ? (this.chechDiscount(merchantClient, det.price, det) * products.quantity * det.quantity) : 0;
          });
        }
        countTot += !products.free ? (this.chechDiscount(merchantClient, products.price, products) * products.quantity) : 0
      })
    }
    return (Math.round(countTot * 100) / 100);
  }

  chechDiscount(merchantClient: any, price: any, prod: any) {
    let newVal: any = price;
    if (merchantClient && merchantClient.id_group) {
      if (merchantClient.discount) {
        newVal = price * ((100 - merchantClient.discount) / 100)
      }
      if (merchantClient.groups_discount && merchantClient.groups_discount.length > 0 && prod && prod.rubric) {
        const discount_prod_rubric = merchantClient.groups_discount.find((value: any) => value.id_rubric == prod.rubric.id);
        if (discount_prod_rubric) {
          newVal = price * ((100 - discount_prod_rubric.discount) / 100);
        }
      }
    }
    return (Math.round(newVal * 100) / 100);
  }


  getPriceWithFidelityCagnotte(amount: any) {
    const price = this.getPrice();
    const result = (amount && amount < price) ? price - amount : !amount ? price : 0;
    return Math.round(result * 100) / 100;
  }

  //Init basket from existing order
  initBasketFromOrder(basket: any[], products: any[], cats: any[]) {
    products = _.cloneDeep(products);
    const newBasket = [];
    const missingProds = [];
    const differentPriceProds: any = [];
    // BASKET
    for (let a = 0; a < basket.length; a++) {
      const basketProd = basket[a];
      basketProd.missingProd = true;
      basketProd.differentPriceProd = false;
      basketProd.missingDetails = [];
      // PRODUCT
      for (let b = 0; b < products.length; b++) {
        const apiProd = products[b];
        if (basketProd.product.id === apiProd.id) {
          basketProd.apiProd = apiProd;
          if (apiProd.prices[0].price !== basketProd.price) {
            basketProd.differentPriceProd = true;
            basketProd.nowPrice = apiProd.prices[0].price;
          }
          apiProd.details = [];
          apiProd.quantity = basketProd.quantity;
          basketProd.missingProd = false;
          basketProd.categories = this.setProdCat(apiProd, cats);
          if (basketProd.details) {
            this.parseDetails(basketProd, apiProd, cats, products, differentPriceProds, basketProd, apiProd);
            if (!basketProd.missingProd) {
              newBasket.push(apiProd);
            }
          } else {
            newBasket.push(apiProd);
            break;
          }
        }
      }
      if (basketProd.missingProd) {
        missingProds.push(basketProd);
      }
      if (basketProd.differentPriceProd) {
        // Set differentPriceProds
        this.pushDifferentPriceProd(differentPriceProds, basketProd);
      }
    }
    // Set recovery changes if exists
    if (missingProds.length > 0 || differentPriceProds.length > 0) {
      const recoveryChanges = {
        missingProds: missingProds,
        differentPriceProds: differentPriceProds
      }
      this.setRecoveryOrderChanges(recoveryChanges);
    }
    // Set basket with parsed valid prods
    newBasket.map(prod => {
      (prod.product_type < 2) ? this.manageProduct(prod) : this.manageProductFormule(prod, prod.details);
    });
  }

  parseDetails(basketProd: any, apiProd: any, cats: any[], products: any[], differentPriceProds: any[], holdBaseBasket: any, holdProdApi: any) {
    const newDetails = [];
    // BASKETPROD.DETAILS
    for (let b = 0; b < basketProd.details.length; b++) {
      const basketProdDetail = basketProd.details[b];
      // Just for product_type_2
      if (basketProd.product && basketProd.product.product_type === 2) {
        // Get categories by product object
        this.parseProds(basketProdDetail, cats, products);
      }
      basketProdDetail.quantity = 1;
      basketProdDetail.missingProd = true;
      basketProdDetail.differentPriceProd = false;
      basketProdDetail.missingDetails = [];
      // BASKETPROD.CATEGORIES
      for (let c = 0; c < basketProd.categories.length; c++) {
        const basketProdCategorie = basketProd.categories[c];
        if (!basketProdDetail.missingProd) {
          break;
        }
        // BASKETPROD.CATEGORIES.DETAILS
        for (let e = 0; e < basketProdCategorie.details.length; e++) {
          const apiCatDetail = basketProdCategorie.details[e];
          if (basketProdDetail.id_product === apiCatDetail.product.id && basketProdDetail.id_category === basketProdCategorie.id) {
            apiCatDetail.product.details = [];
            apiCatDetail.product.quantity = 1;
            apiCatDetail.product.cat = basketProdCategorie.id;
            basketProdDetail.missingProd = false;
            basketProdDetail.fromProd = basketProd.name;
            basketProdDetail.fromProd_image = basketProd.apiProd.image;
            basketProdDetail.cat_name = basketProdCategorie.name;
            if (basketProdDetail.price !== apiCatDetail.product.price) {
              basketProdDetail.differentPriceProd = true;
              basketProdDetail.nowPrice = apiCatDetail.product.price;
            }
            apiProd.details.push(apiCatDetail.product);
            // Just for product_type_2
            if (basketProdDetail.details) {
              this.parseDetails(basketProdDetail, apiCatDetail.product, cats, products, differentPriceProds, holdBaseBasket, holdProdApi);
              if (!basketProdDetail.missingProd) {
                newDetails.push(apiCatDetail.product);
              }
              // Just for product_type_1
            } else {
              newDetails.push(apiCatDetail.product);
            }
          }
        }
      }
      if (basketProdDetail.missingProd) {
        basketProd.missingProd = true;
        basketProd.differentPriceProd = false;
        basketProd.missingDetails.push(basketProdDetail);
      }
      if (basketProdDetail.differentPriceProd) {
        // Set differentPriceProds
        this.pushDifferentPriceProd(differentPriceProds, basketProdDetail);
      }
    }
    holdProdApi.details = newDetails;
  }

  // Get prod by basket prod and replace categories
  parseProds(basketProd: any, cats: any[], products: any[]) {
    for (let b = 0; b < products.length; b++) {
      const apiProd = products[b];
      if (basketProd.id_product === apiProd.id) {
        basketProd.categories = this.setProdCat(apiProd, cats);
        basketProd.apiProd = apiProd;
      }
    }
  }

  // Get categories by prod
  setProdCat(prod: any, cats: any[]) {
    const prodCats: any = []
    if (prod.categories) {
      prod.categories.map((prodCat: any) => {
        cats.map(apiCat => {
          if (prodCat.id === apiCat.id) {
            prodCats.push(apiCat);
          }
        });
      });
    }
    return prodCats;
  }

  // Check if prod exist in different price array before push this one
  pushDifferentPriceProd(myArray: any[], dataToPush: any) {
    let push = true;
    for (let a = 0; a < myArray.length; a++) {
      const arrayProd = myArray[a];
      if (dataToPush.product) {
        if (arrayProd.id_product === dataToPush.id_product) {
          push = false;
        }
      } else {
        if (
          arrayProd.id_category === dataToPush.id_category && arrayProd.id_product === dataToPush.id_product
        ) {
          push = false;
        }
      }
    }
    if (push) {
      myArray.push(dataToPush)
    }
  }

  // Set observable recovery changes
  setRecoveryOrderChanges(orderChanges: any) {
    this.recoveryOrderChanges.next(orderChanges);
  }

  // Get observable recovery changes
  getRecoveryOrderChanges(): Observable<any> {
    return this.recoveryOrderChanges.asObservable();
  }

  // Renvoi un nouveau basket avec la liste des produits utilisables avec le points Fidelity
  getBasketFidelityPoints(ClientFidelityPoints: any): any {
    const panier = _.cloneDeep(this.currPanier.getValue());
    const separateBasket: any = [];
    panier.map(prod => {
      if (prod.fidelity_points && prod.fidelity_points <= ClientFidelityPoints) {
        prod.uid = prod.uid ? prod.uid : uuidv4();
        if (prod.quantity > 1) {
          for (let index = 0; index < prod.quantity; index++) {
            const prodcopy = _.cloneDeep(prod);
            prodcopy.quantity = 1;
            separateBasket.push(prodcopy);
          }
        } else {
          separateBasket.push(prod);
        }
      } else {
        separateBasket.push(prod);
      }
    });
    return separateBasket;
  }

  checkarrayfid(array: any, oldfid: any) {
    let result = 0;
    for (let index = 0; index < array.length; index++) {
      const element = array[index];
      if (element.fidelity_points && element.fidelity_points <= oldfid) {
        result++;
      }
    }
    return result;
  }

  // recree un nouveau basket
  setBasketFidelityPoints(newbasket: any): any {
    const ASSOC_FINAL: any = [];
    for (let index = 0; index < newbasket.length; index++) {
      const element = newbasket[index];
      element.free = element.selected ? 1 : 0;
      element.use_fidelity_points = element.selected ? 1 : 0;
      element.total_ttc = this.getProdTotal(element);
      //on associe
      if (ASSOC_FINAL[element.id + "-" + element.use_fidelity_points + "-" + element.uid]) {
        ASSOC_FINAL[element.id + "-" + element.use_fidelity_points + "-" + element.uid].quantity++;
      } else {
        ASSOC_FINAL[element.id + "-" + element.use_fidelity_points + "-" + element.uid] = element;
      }
    }
    //on reconstruit
    const newArray = []
    const ArrayF = Object.keys(ASSOC_FINAL);
    for (let i = 0; i < ArrayF.length; i++) {
      const item = ArrayF[i];
      newArray.push(ASSOC_FINAL[item]);
    }
    const arraytoReturn = this.detailsLoyaltyPoints(newArray);
    return arraytoReturn;
  }

  // retourne le nombre de point avec de la fid
  getClientFidelityPoints(clientFidelityPoint: any) {
    let countTot = 0;
    const panier = _.cloneDeep(this.currPanier.getValue());
    panier.map(det => {
      if (det.free) {
        countTot += det.fidelity_points * det.quantity
      }
    });
    const result = (clientFidelityPoint - countTot) >= 0 ? clientFidelityPoint - countTot : 0;
    return result;
  }

  resetClientFidelityPoints() {
    const panier: any = _.cloneDeep(this.currPanier.getValue());
    panier.map((det: any) => {
      det.free = det.selected ? 0 : det.free;
      det.total_ttc = this.getProdTotal(det);
      det.use_fidelity_points = det.selected ? 0 : det.use_fidelity_points;
    });
    return panier;
  }


  // retourne le tableau des details incrementé en fidelité
  detailsLoyaltyPoints(newArray: any) {
    newArray.map((el: any) => {
      if (el.details && el.details.length > 0) {
        for (let index = 0; index < el.details.length; index++) {
          const details = el.details[index];
          details.free = el.free ? 1 : 0;
          details.use_fidelity_points = el.use_fidelity_points ? 1 : 0;
          if (details.details && details.details.length > 0) {
            for (let index = 0; index < el.details.length; index++) {
              const details = el.details[index];
              details.free = el.free ? 1 : 0;
              details.use_fidelity_points = el.use_fidelity_points ? 1 : 0;
            }
          }
        }
      }
    });
    return newArray;
  }
}